<template>
  <Layout
    class="main-layout"
    max-width="100%"
  >
    <NotifySection />
    <NewsSection />
    <ShortcutSection />
    <WorkerCreditHubDashboard />
    <SimplifiedProposalTable />
  </Layout>
</template>
<script>
import seo from '@/utils/seo';

import Layout from '@/layouts/Layout.vue';
import NotifySection from '@/components/Hub/NotifySection.vue';
import NewsSection from '@/components/Hub/NewsSection.vue';
import ShortcutSection from '@/components/Hub/ShortcutSection.vue';
import WorkerCreditHubDashboard from '@/components/WorkerCredit/HubDashboard.vue';
import SimplifiedProposalTable from '@/components/Hub/SimplifiedProposalTable.vue';

export default {
  name: 'TypistHub',
  components: {
    Layout,
    NotifySection,
    NewsSection,
    ShortcutSection,
    WorkerCreditHubDashboard,
    SimplifiedProposalTable,
  },
  data() {
    return {
      meta: {
        title: 'Página Inicial',
      },
      modal: {
        // ...
      },
    };
  },
  methods: {
    close({ key }) {
      this.modal[key] = false;
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>
<style lang="scss" scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
